import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

import { reformatLot } from '../../../selectors/lots'

const initial = {
  items: {},
  keys: {},
  count: {},
  filters: {}
}

const fetchActions = generateActions(`lots/list/FETCH`)
const fetchCountActions = generateActions(`lots/list/FETCH_COUNT`)

export const clearKeys = createAction('lots/list/CLEAR_KEYS', type => ({ type }))

export const getList = createAction(
  API_CONST,
  (type, params = {}) => ({
    actions: fetchActions,
    url: 'lots',
    params: { ...params, sort: type }
  }),
  (type, params = {}) => ({ type, rewrite: !params.offset })
)

export const getCount = createAction(
  API_CONST,
  (type, params = {}) => ({
    params,
    url: 'lots/count',
    actions: fetchCountActions
  }),
  type => ({ type })
)

export const setFilters = createAction(
  'lots/list/FILTERS_SET',
  (filters = {}) => ({ filters })
)

const reduceItems = (items = []) => {
  return items.reduce((object, item) => {
    object[item._id] = reformatLot(item)
    return object
  }, {})
}

export default handleActions({
  // [fetchActions[0]]: (state, { meta }) => ({
  //   ...state,
  //   keys: {
  //     ...state.keys,
  //     [meta.type]: meta.rewrite ? [] : [ ...(state.keys[meta.type] || []) ]
  //   }
  // }),
  [fetchActions[1]]: (state, { payload = [], meta }) => {
    let keys = payload.map(el => el._id)
    return {
      ...state,
      keys: {
        ...state.keys,
        [meta.type]: meta.rewrite ? keys : [ ...(state.keys[meta.type] || []), ...keys ]
      },
      items: {
        ...state.items,
        ...reduceItems(payload)
      }
    }
  },
  [fetchCountActions[1]]: (state, { payload, meta }) => ({
    ...state,
    count: { ...state.count, [meta.type]: payload.value }
  }),
  [clearKeys]: (state, { payload }) => ({
    ...state,
    keys: {
      ...state.keys,
      [payload.type]: []
    }
  }),
  [setFilters]: (state, { payload }) => ({ ...state, filters: payload.filters || {} })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/lots/list.js